import { defineBlocksWithJsonArray } from 'blockly/core';

import {
  BEGINNER_PIXEL_EFFECT_OPTIONS,
  BEGINNER_PRESET_COLOR_OPTIONS,
} from '../constants.js';
import {
  brightnessPercentField,
  getBeginnerPixelDataPinOptions,
} from '../helpers/block-builders.js';
import { BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION } from '../helpers/pixel-colour-extension.js';

const LED_BLOCK_STYLE = 'beginner_led_blocks';

function beginnerColourField(name: string, colour = '#ff0000') {
  return {
    type: 'field_beginner_colour',
    name,
    colour,
  };
}

const pixelLedBlockDefinitions = [
  {
    type: 'beginner_pixel_configure',
    message0: 'configure WS2812 pixel LED data pin %1 number of LEDs %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'DATA_PIN',
        options: getBeginnerPixelDataPinOptions,
      },
      {
        type: 'field_number',
        name: 'LED_COUNT',
        value: 8,
        min: 1,
        max: 256,
        precision: 1,
      },
    ],
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Sets up a WS2812 pixel LED strip or ring.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_set_color',
    message0: 'set pixel %1 color %2 %3',
    args0: [
      {
        type: 'field_number',
        name: 'PIXEL',
        value: 0,
        min: 0,
        max: 255,
        precision: 1,
      },
      {
        type: 'field_dropdown',
        name: 'COLOR',
        options: BEGINNER_PRESET_COLOR_OPTIONS,
      },
      beginnerColourField('CUSTOM_COLOUR', '#ff0000'),
    ],
    extensions: [BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION],
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Sets the color of one pixel LED.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_set_all',
    message0: 'set all pixels color %1 %2',
    args0: [
      {
        type: 'field_dropdown',
        name: 'COLOR',
        options: BEGINNER_PRESET_COLOR_OPTIONS,
      },
      beginnerColourField('CUSTOM_COLOUR', '#ff0000'),
    ],
    extensions: [BEGINNER_PIXEL_CUSTOM_COLOUR_EXTENSION],
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Sets every pixel LED to the same color.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_clear',
    message0: 'clear pixels',
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Turns all pixel LEDs off in memory.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_show',
    message0: 'show pixels',
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Updates the pixel LEDs with the latest colors.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_brightness',
    message0: 'set pixel brightness %1 %',
    args0: [brightnessPercentField('BRIGHTNESS', 100)],
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Sets how bright the pixel LEDs shine using a percentage.',
    helpUrl: '',
  },
  {
    type: 'beginner_pixel_effect',
    message0: 'pixel effect %1',
    args0: [
      {
        type: 'field_dropdown',
        name: 'EFFECT',
        options: BEGINNER_PIXEL_EFFECT_OPTIONS,
      },
    ],
    previousStatement: null,
    nextStatement: null,
    style: LED_BLOCK_STYLE,
    tooltip: 'Runs a light effect on the pixel LEDs.',
    helpUrl: '',
  },
];

export function registerBeginnerPixelLedBlocks(): void {
  defineBlocksWithJsonArray(pixelLedBlockDefinitions);
}
